if (!customElements.get('viro-pdp-sticky')) {
  customElements.define('viro-pdp-sticky', class extends HTMLElement {
    connectedCallback() {
      this.root = document.getElementById(this.dataset.productInfo);
      this.button = this.querySelector('button');
      this.price = this.querySelector('[data-sticky-price]');
      if (!this.root || !this.button) return;
      this.update = () => {
        const submit = this.root.querySelector('button[name="add"]');
        if (!submit) { this.hidden = true; return; }
        const box = submit.getBoundingClientRect();
        const dialogOpen = document.querySelector('cart-drawer.active, cart-notification.active, dialog[open], .shopify-payment-button__button[aria-expanded="true"]');
        this.hidden = Boolean(dialogOpen) || (box.top >= 0 && box.bottom <= window.innerHeight);
        this.pastButton = box.bottom < 0;
        this.needsSize = this.root.closest('product-info')?.dataset.needsSize === 'true';
        this.button.disabled = !this.needsSize && (submit.disabled || submit.getAttribute('aria-disabled') === 'true');
        const sourceLabel = submit.querySelector('span')?.textContent.trim();
        this.button.textContent = this.needsSize ? this.dataset.sizesLabel : this.button.disabled || this.pastButton ? sourceLabel : this.dataset.optionsLabel;
        const priceRoot = this.root.querySelector('[id^="price-"]');
        const currentPrice = priceRoot?.querySelector('.price--on-sale .price-item--sale') || priceRoot?.querySelector('.price__regular .price-item--regular');
        this.price.textContent = currentPrice?.textContent.trim() || '';
      };
      this.refresh = () => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => {
          this.frame = null;
          this.update();
        });
      };
      this.onClick = () => {
        const submit = this.root.querySelector('button[name="add"]');
        if (!submit || this.button.disabled) return;
        if (this.pastButton && !this.needsSize) submit.click();
        else {
          const picker = this.root.querySelector('variant-selects');
          const position = Number(this.root.querySelector('viro-size-confirm')?.dataset.position || 0);
          const fields = picker?.querySelectorAll('fieldset, .product-form__input--dropdown');
          const purchase = fields?.[position - 1] || (picker?.getClientRects().length ? picker : submit);
          purchase.scrollIntoView({ behavior: 'instant', block: 'center' });
          const focus = purchase.querySelector('input:not([disabled]):not(.disabled), select:not([disabled])') || purchase;
          focus.focus({ preventScroll: true });
        }
      };
      this.button.addEventListener('click', this.onClick);
      window.addEventListener('scroll', this.refresh, { passive: true });
      window.addEventListener('resize', this.refresh);
      this.observer = new MutationObserver(this.refresh);
      this.observer.observe(this.root, { subtree: true, childList: true, attributes: true, attributeFilter: ['disabled', 'aria-disabled', 'class'] });
      this.cartObserver = new MutationObserver(this.refresh);
      for (const cart of document.querySelectorAll('cart-drawer, cart-notification')) this.cartObserver.observe(cart, { attributes: true, attributeFilter: ['class'] });
      this.refresh();
    }
    disconnectedCallback() {
      window.removeEventListener('scroll', this.refresh);
      window.removeEventListener('resize', this.refresh);
      this.button?.removeEventListener('click', this.onClick);
      this.observer?.disconnect();
      this.cartObserver?.disconnect();
      cancelAnimationFrame(this.frame);
      this.frame = null;
    }
  });
}

if (!customElements.get('viro-size-confirm')) {
  customElements.define('viro-size-confirm', class extends HTMLElement {
    connectedCallback() {
      this.root = this.closest('product-info');
      if (!this.root || this.controller) return;
      this.controller = new AbortController();
      this.confirmed = this.dataset.explicit === 'true';
      this.fields = () => this.root.querySelectorAll('variant-selects fieldset, variant-selects .product-form__input--dropdown');
      this.sizeField = () => this.fields()[Number(this.dataset.position) - 1];
      const field = this.sizeField();
      if (!this.confirmed && field) {
        field.querySelectorAll('input[type="radio"]').forEach(input => { input.checked = false; });
        const select = field.querySelector('select');
        if (select) { const option = document.createElement('option'); option.value = ''; option.textContent = this.dataset.label; option.disabled = true; option.selected = true; select.prepend(option); }
      }
      this.guard = () => {
        this.root.dataset.needsSize = String(!this.confirmed);
        if (this.confirmed) return;
        this.sizeField()?.querySelectorAll('input[type="radio"]').forEach(input => { input.checked = false; });
        const button = this.root.querySelector('button[name="add"]');
        if (!button) return;
        if (button.disabled) button.disabled = false;
        if (button.getAttribute('aria-disabled') === 'true') button.removeAttribute('aria-disabled');
        const label = button.querySelector('span');
        if (label && label.textContent !== this.dataset.jumpLabel) label.textContent = this.dataset.jumpLabel;
      };
      this.jumpToSize = () => {
        const field = this.sizeField();
        if (!field) return;
        field.scrollIntoView({ block:'center', behavior: 'instant' });
        field.querySelector('input:not([disabled]):not(.disabled), select:not([disabled])')?.focus({ preventScroll:true });
      };
      this.root.addEventListener('click', event => {
        if (this.confirmed || !event.target.closest('button[name="add"]')) return;
        event.preventDefault(); event.stopImmediatePropagation(); this.jumpToSize();
      }, { capture:true, signal:this.controller.signal });
      this.root.addEventListener('change', event => {
        if (!this.sizeField()?.contains(event.target) || !event.target.value) return;
        this.confirmed = true;
        this.root.dataset.needsSize = 'false';
      }, { capture: true, signal: this.controller.signal });
      this.root.addEventListener('submit', event => {
        if (this.confirmed) return;
        event.preventDefault(); event.stopImmediatePropagation();
        this.jumpToSize();
      }, { capture: true, signal: this.controller.signal });
      this.observer = new MutationObserver(this.guard);
      this.observer.observe(this.root, { subtree:true, childList:true, attributes:true, attributeFilter:['disabled','aria-disabled'] });
      this.guard();
    }
    disconnectedCallback() { this.observer?.disconnect(); this.controller?.abort(); this.controller = null; }
  });
}
